import { getExpiredTabIds } from 'features/load-hub/utils/localStorage'
export const BOX_TRUCK_WORKSPACE_TTL_MS = 7 * 24 * 60 * 60 * 1000

/** Box Truck keeps the shared missing-stamp behavior with its own seven-day lifetime. */
export const getExpiredBoxTruckTabIds = (tabIds: string[], createdKey: string): string[] => getExpiredTabIds(tabIds, createdKey, BOX_TRUCK_WORKSPACE_TTL_MS)
